// Single source of SEO metadata for the Dutch-only legal routes (/agb/, /privacy/).
//
// These pages are intentionally NOT in TRANSLATED_ROUTES — they are Dutch-only, so
// their head is language-INDEPENDENT: a fixed Dutch self-canonical, index robots, and
// og/twitter built from the values below. Both the runtime page (src/components/
// LegalSEO.tsx) and the build-time shell (scripts/build-shells.mjs) read from here, so
// the raw prerendered head and the hydrated head can never drift.
//
// Pure (no React) so scripts/build-shells.mjs can import it via esbuild.

export interface LegalSeo {
  /** Dutch base route, trailing-slash form. */
  base: '/agb/' | '/privacy/';
  title: string;
  description: string;
  /** Site-relative OG/Twitter image. */
  image: string;
  /** Visible page H1 — also baked into the no-JS static shell so it matches. */
  h1: string;
  /** Short intro under the H1 — page + shell share it. */
  intro: string;
}

export const LEGAL_SEO: Record<'/agb/' | '/privacy/', LegalSeo> = {
  '/agb/': {
    base: '/agb/',
    title: 'Algemene Voorwaarden — Klipper Johanna Engelina',
    description:
      'Algemene voorwaarden van klipper Johanna Engelina. Boekingsvoorwaarden, annuleringsbeleid en reisvoorwaarden voor zeiltochten en arrangementen.',
    image: '/images/ship.jpg',
    h1: 'Algemene Voorwaarden',
    intro: 'Informatie over boekingen, vertrekhavens, capaciteit en annuleringsbeleid.',
  },
  '/privacy/': {
    base: '/privacy/',
    title: 'Privacybeleid — Klipper Johanna Engelina',
    description:
      'Privacybeleid van klipper Johanna Engelina. Hoe wij omgaan met uw persoonsgegevens conform de AVG.',
    image: '/images/ship.jpg',
    h1: 'Privacybeleid',
    intro: 'Hoe wij omgaan met uw persoonsgegevens en uw privacy beschermen.',
  },
};
